import apiClient from "./apiClient";

const produzioniAPI = {
  getAllProduzioni: () =>
    apiClient.get(`/produzioni/index?company_id=${localStorage.getItem('company_id')}`),

  createProduzione: (data) =>
    apiClient.post(`/produzioni/store?company_id=${localStorage.getItem('company_id')}`, data),

  updateProduzione: (id, data) =>
    apiClient.post(`/produzioni/update/${id}?company_id=${localStorage.getItem('company_id')}`, data),

  deleteProduzione: (id) =>
    apiClient.delete(`/produzioni/delete/${id}?company_id=${localStorage.getItem('company_id')}`),

  getSingleProduzione: (id) =>
    apiClient.get(`/produzioni/get-step-form-data/${id}?company_id=${localStorage.getItem('company_id')}`),
};

export default produzioniAPI;
